import { render, staticRenderFns } from "./ed-presentation-mode-student.component.vue?vue&type=template&id=32af8358&scoped=true&"
import script from "./ed-presentation-mode-student.component.ts?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-student.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-student.component.scss?vue&type=style&index=0&id=32af8358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af8358",
  null
  
)

export default component.exports